import { AnalyticsSdk, generateUUID, getTimeZone, getSessionID } from '../pdtUtils';
import {
  LOB_RAILS,
  EVENT_NAME_PAGE_RENDERED,
  EVENT_TYPE_PAGE,
  STORE_ID_MMT,
  ORGANISATION_MMT,
  BU_GROUND_TRANSPORT,
  TRAFFIC_SOURCE_ORGANIC,
  PDT_SCHEMA_ID,
  PDT_SCHEMA_NAME,
  PAGE_TYPE_TEMPLATE,
  PAGE_NAME_SEO,
  FUNNEL_STEP_DETAIL,
  FUNNEL_SOURCE_SEO
} from '../constants';

export const logIrctcInfoPageLoadEvent = async (pageIdentifier: string) => {
  try {
    if (typeof window === 'undefined' || !AnalyticsSdk || !pageIdentifier) return;

    const isDev = process.env.NODE_ENV !== 'production';
    const sessionId = getSessionID();
    const journeyId = generateUUID();

    const components = {
      id: 'irctc_info_page_load',
      component_type: 'irctc_info'
    };

    const searchContext = {
      from: {
        locus: { locus_id: 'NA', locus_type: 'NA', country: 'India', locus_v2_id: 'NA', locus_v2_type: 'NA' },
        location: { code: 'NA', name: 'NA', country_code: 'IN', country: 'India' }
      },
      to: {
        locus: { locus_id: 'NA', locus_type: 'NA', country: 'India', locus_v2_id: 'NA', locus_v2_type: 'NA' },
        location: { code: 'NA', name: 'NA', country_code: 'IN', country: 'India' }
      },
      travel_class: 'All',
      advance_purchase: 'NA'
    };

    const payload = {
      page_context: {
        lob: LOB_RAILS,
        page_type: PAGE_TYPE_TEMPLATE,
        page_name: pageIdentifier,
        prev_page_name: PAGE_NAME_SEO,
        funnel_step: FUNNEL_STEP_DETAIL,
        lob_category: LOB_RAILS,
        travel_store: { store_id: STORE_ID_MMT }
      },
      event_tracking_context: {
        env: isDev ? 'dev' : 'prod',
        timezone: getTimeZone(),
        session_id: sessionId,
        funnel_source: FUNNEL_SOURCE_SEO,
        bu: BU_GROUND_TRANSPORT,
        organisation: ORGANISATION_MMT,
        journey_id: journeyId,
        traffic_source: TRAFFIC_SOURCE_ORGANIC,
        template_id: PDT_SCHEMA_ID,
        topic_name: PDT_SCHEMA_NAME
      },
      search_context: searchContext,
      event_detail: {
        event_name: EVENT_NAME_PAGE_RENDERED,
        event_type: EVENT_TYPE_PAGE,
        event_id: generateUUID(),
        event_timestamp: Date.now(),
        event_value: pageIdentifier,
        components
      },
      experiment_details: {
        valid_exp_list: [] as string[],
        variant_keys: '',
        honoured_exp_list: [] as string[]
      }
    };

    const xdmPayload = {
      ...payload,
      event_detail: {
        ...payload.event_detail,
        components: [components]
      }
    };

    const extraOptions = { lob: LOB_RAILS, destinationUrl: window?.location?.href || '' };

    AnalyticsSdk?.pushToPDT?.(payload, extraOptions);
    AnalyticsSdk?.pushToAdobeDataLayer?.(xdmPayload, extraOptions);
  } catch (e) {
    console.error('Analytics: IRCTC info page load event failed', e);
  }
};
